export default __webpack_public_path__ + "static/media/2852.51b84350.png";